import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loan-application-form-3"
export default class extends Controller {
  static values = { financeCase: String, isInstantLoan: Boolean, brokerForm: Boolean, companyName: String }
  static targets = [
    "inputContainer",
    "crefonummer",
    "submitButton",
    "practiceNotInSmartSignUpInput",
    "legalForm",
    "medicalSpecialisation",
    "companyNameFieldLabel",
    "addressFieldLabel",
    "companyFieldContainer",
    "companyFieldInput",
    "concessionsContainer",
    "hasNoConcessions",
    "practiceFormContainer",
    "practiceFormField",
    "foundationLabel"
  ];

  cachedName = '';
  practiceSelected = false;

  connect() {
    this.cachedName = this.companyNameValue;
    this.reevaluate();
  }

  reevaluate() {
    this.reevaluateShowInputs();
    this.reevaluateConcessions();
    this.reevaluatePracticeForm();
    this.reevaluateCompanyField();
    this.reevaluateFoundationLabel();
  }

  reevaluateShowInputs() {
    if (!this.isInstantLoanValue || this.practiceSelected || this.brokerFormValue ) {
      this.inputContainerTargets.forEach(input => input.classList.remove('is-hidden'));
      this.submitButtonTargets.forEach(button => button.classList.remove('is-hidden'));
    } else {
      this.inputContainerTargets.forEach(input => input.classList.add('is-hidden'));
      this.submitButtonTargets.forEach(button => button.classList.add('is-hidden'));
    }
  }

  reevaluateFoundationLabel() {
    const spec = this.medicalSpecialisationTarget.value;
    const foundationLabel = (() => {
      if (this.financeCaseValue === 'New Practice') {
        return 'Wann wollen Sie gründen?';
      } else if (this.financeCaseValue === 'Buy Practice') {
        return 'Wann wollen Sie übernehmen?'
      } else {
        {
          if (spec == null || spec == '') {
            return "Wann wurde gegründet?";
          } else if (spec == 'Pharmacist') {
            return 'Wann wurde die Apotheke gegründet?';
          } else if (spec == 'Nursery') {
            return 'Wann wurde das Unternehmen gegründet?';
          } else {
            return 'Wann wurde die Praxis gegründet?';
          }
        }
      }
    })()
    this.foundationLabelTarget.innerText = foundationLabel;
  }

  reevaluatePracticeForm() {
    const show = !['Pharmacist','Nursery'].includes(this.medicalSpecialisationTarget.value)
    if (show) {
      this.practiceFormContainerTarget.classList.remove('is-hidden');
      this.practiceFormContainerTarget.classList.add('presence-validated');

    } else {
      Array.from(this.practiceFormFieldTarget.children).forEach(element => {
        if (element.value === null) {
          element.selected = 'selected'
        } else {
          element.selected = null
        }

      })

      this.practiceFormContainerTarget.classList.add('is-hidden');
      this.practiceFormContainerTarget.classList.remove('presence-validated');
    }
  }

  reevaluateConcessions() {
    if (this.medicalSpecialisationTarget.value === 'Pharmacist') {
      this.concessionsContainerTarget.classList.add("is-hidden");
      this.hasNoConcessionsTarget.checked = true
    } else {
      this.concessionsContainerTarget.classList.remove("is-hidden");
    }
  }

  reevaluateCompanyField() {
    const showContainer = ['Pharmacist','Nursery'].includes(this.medicalSpecialisationTarget.value) || this.practiceFormFieldTarget.value !== '' && this.legalFormTarget.value !== '' && (this.legalFormTarget.value !== 'Self-Employed' || this.practiceFormFieldTarget.value !== 'Solo');
    const companyLabel = ['Pharmacist','Nursery'].includes(this.medicalSpecialisationTarget.value) ? "Firma / Geschäftsname" : "Firma / Praxisname"
    const addressLabel = ['Pharmacist','Nursery'].includes(this.medicalSpecialisationTarget.value) ? "Geschäftsadresse" : "Praxisadresse"

    this.companyNameFieldLabelTarget.innerText = companyLabel;
    this.addressFieldLabelTarget.innerText = addressLabel;
    if (showContainer) {
      this.companyFieldInputTarget.value = this.cachedName;
      this.companyFieldContainerTarget.classList.remove('is-hidden');
      this.companyFieldContainerTarget.classList.add('presence-validated');
    } else {
      this.companyFieldInputTarget.value = '';
      this.companyFieldContainerTarget.classList.add('is-hidden');
      this.companyFieldContainerTarget.classList.remove('presence-validated');
    }
  }

  selectPractice(event) {
    this.cachedName = event.detail.companyName;
    this.cachedCrefoNummer = event.detail.crefonummer;
    this.practiceNotInSmartSignUpInputTarget.value = false;
    this.practiceNotInSmartSignUpInputTarget.checked = false;
    this.practiceSelected = true;
    this.reevaluate();
  }

  cacheCurrentNameValue() {
    this.cachedName = this.companyFieldInputTarget.value;
  }

  setIsInstantLoan() {
    this.isInstantLoanValue = !this.practiceNotInSmartSignUpInputTarget.checked;
    if (!this.isInstantLoanValue) {
      this.practiceSelected = false;
      this.crefonummerTarget.value = '';
      this.dispatch("notInSmartSignUp", {});
    }
    this.reevaluate();
  }
}
